import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable, EMPTY } from 'rxjs';
import { take, catchError } from 'rxjs/operators';

import { MasterDataService } from '@service/master-data.service';

import { ExcludedCountry } from '@model/master-data.model';

@Component({
  selector: 'app-excluded-countries',
  templateUrl: './excluded-countries.component.html',
  styleUrls: ['./excluded-countries.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExcludedCountriesComponent implements OnInit {
  isError: boolean = false;
  excludedCountries$: Observable<ExcludedCountry[]>;

  constructor(private masterDataService: MasterDataService) {}

  ngOnInit(): void {
    this.getExcludedCountries();
  }

  getExcludedCountries(): void {
    this.excludedCountries$ = this.masterDataService.getExcludedCountries().pipe(
      take(1),
      catchError((error: any) => {
        if (error) {
          this.isError = true;
        }

        return EMPTY;
      })
    );
  }
}
